export default __webpack_public_path__ + "a9b1a432329ee85ab44d73fda39c6f28.png";